import { getCategoryHref } from '../../utils/common/category';
import { STORY_IDEA_GENERATOR_CATEGORY } from '../../constants';

import { chipValues } from './shared';

const data = [
  {
    type: 'chips',
    properties: {
      isAdvanced: false,
      name: 'storyIdeaGeneratorType',
      analyticsName: 'story_idea_type',
      textLabel: 'Generate story ideas for...',
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: STORY_IDEA_GENERATOR_CATEGORY,
      required: false,
      flex: '100%',
      information: null,
      chipValues,
      defaultChipValue: {
        title: 'Story',
        value: getCategoryHref(STORY_IDEA_GENERATOR_CATEGORY),
      },
    },
  },
  {
    type: 'input',
    properties: {
      name: 'storyIdeaGeneratorTopic',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'story_ideas_generator',
      placeholder: 'Try "fun story about growing up" or "creative bit about building houses"',
      textLabel: 'Describe the kind of story',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      selectedCategory: STORY_IDEA_GENERATOR_CATEGORY,
      required: true,
      tooltipProps: null,
    },
  },
];

export default data;
